import { FC } from "react";
import { generatePath, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  isChatPath,
  useCountUnreadChats,
  useGetProfileMenuRoutes,
  useCountMatchesActions
} from "../../../utils/navbar";
import { TMenuRoute } from "../../../routes";

import {
  StickyNavbarContainer,
  StickyNavbarItem,
  StyledStickyNavbar,
  NavbarInfoContainer
} from "./styles";

export const MobileStickyNavbar: FC = () => {
  const profileNavbarRoutes = useGetProfileMenuRoutes();
  const { t, i18n } = useTranslation("header");
  const { language } = i18n;
  const stickyNavbarRoutes: TMenuRoute[] = profileNavbarRoutes.filter(
    (item) => item.keyLocalize !== "blog"
  );
  const unreadCount = useCountUnreadChats();
  const matchesActionsCount = useCountMatchesActions();

  return (
    <StyledStickyNavbar>
      <StickyNavbarContainer $itemsAmount={stickyNavbarRoutes.length}>
        {stickyNavbarRoutes.map((item) => (
          <StickyNavbarItem key={`mobileStickyNavbar${item.keyLocalize}`}>
            <NavLink
              to={generatePath(item.path, {
                lng: language,
                id: isChatPath(item.path) ? "all" : ""
              })}
            >
              {item.icon}
              <span>
                {t(`subMenu.${item.keyLocalize}`)}
                {!!unreadCount && item.keyLocalize === "chats" ? (
                  <NavbarInfoContainer>
                    <span className="navbarInfo">{unreadCount}</span>
                  </NavbarInfoContainer>
                ) : null}
                {!!matchesActionsCount &&
                (item.keyLocalize === "tenants" ||
                  item.keyLocalize === "stay") ? (
                  <NavbarInfoContainer
                    className={language === "nl" ? "mobileLongNavbarItem" : ""}
                  >
                    <span className="navbarInfo">{matchesActionsCount}</span>
                  </NavbarInfoContainer>
                ) : null}
              </span>
            </NavLink>
          </StickyNavbarItem>
        ))}
      </StickyNavbarContainer>
    </StyledStickyNavbar>
  );
};
